import React from 'react';
import PropTypes from 'prop-types';

const ReportFullscreenContext = React.createContext(null);

export function ReportFullscreenProvider({ children }) {
  const [isReportFullscreen, setIsReportFullscreen] = React.useState(false);

  const enterReportFullscreen = React.useCallback(() => {
    setIsReportFullscreen(true);
  }, []);

  const exitReportFullscreen = React.useCallback(() => {
    setIsReportFullscreen(false);
  }, []);

  React.useEffect(() => {
    if (!isReportFullscreen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsReportFullscreen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isReportFullscreen]);

  const value = React.useMemo(
    () => ({
      isReportFullscreen,
      enterReportFullscreen,
      exitReportFullscreen,
    }),
    [enterReportFullscreen, exitReportFullscreen, isReportFullscreen],
  );

  return (
    <ReportFullscreenContext.Provider value={value}>
      {children}
    </ReportFullscreenContext.Provider>
  );
}

export function useReportFullscreen() {
  const context = React.useContext(ReportFullscreenContext);

  if (!context) {
    throw new Error(
      'useReportFullscreen must be used within ReportFullscreenProvider',
    );
  }

  return context;
}

ReportFullscreenProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
